import { render, staticRenderFns } from "./couponPropertyPoolManageList.vue?vue&type=template&id=2f3d851e&scoped=true"
import script from "./couponPropertyPoolManageList.vue?vue&type=script&lang=js"
export * from "./couponPropertyPoolManageList.vue?vue&type=script&lang=js"
import style0 from "./couponPropertyPoolManageList.vue?vue&type=style&index=0&id=2f3d851e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d851e",
  null
  
)

export default component.exports